<template lang="pug">
    div.profileWrapper(v-if="user.role" :class={ twoLineName: 'twoLineName' })
        div(role="complementary")
            div.roleName {{ user.role }}
            div.userName(v-html="$t('general.hello', { user: user.fullName })" )
        v-menu(offset-y nudge-bottom="20")
            template(v-slot:activator="{ on }")
                div.moreWrapper(v-on="on")
                    img.profileIcon(:src="(user.avatar && !isMember) ? user.avatar : profileIcon" alt="Profile icon")

                    v-icon.moreIcon expand_more
            v-list.profileMenu
                v-list-tile(@click="goToPage('dashboard.profile')")
                    v-list-tile-title {{ $t('general.menu.settings') }}
                v-list-tile(@click="goToPage('dashboard.help')")
                    v-list-tile-title {{ $t('help.title') }}
                v-list-tile(v-if="isAdmin" @click="goToPage('dashboard.feedback')")
                    v-list-tile-title {{ $t('feedback.title') }}
                v-list-tile(v-if="isAdmin" @click="goToPage('dashboard.server.settings')")
                    v-list-tile-title {{ $t('settings.title') }}
                v-list-tile(@click="goToPage('dashboard.privacy')" v-if="$vuetify.breakpoint.smAndDown")
                    v-list-tile-title {{ $t('general.footer.links.privacy') }}
                v-list-tile(@click="goToPage('dashboard.terms')" v-if="$vuetify.breakpoint.smAndDown")
                    v-list-tile-title {{ $t('general.footer.links.termsAndConditions') }}
                v-list-tile(@click="authLogout")
                    v-list-tile-title {{ $t('general.menu.logout') }}
</template>

<script>
    import profileIcon from './Layout/images/ico-profile.svg';
    import Handler from '~services/Handler';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                profileIcon,
                twoLineName: false
            };
        },
        computed: {
            ...mapGetters('auth', ['user', 'isMember', 'isAdmin'])
        },
        createdAt() {
            if (this.user.fullName.length > 15) {
                this.twoLineName = true;
            }
        },
        methods: {
            ...mapActions('auth', ['logout']),

            /**
             * Logout user
             */
            async authLogout() {
                try {
                    await this.logout();

                    this.$router.push({ name: 'auth.login' });
                } catch (e) {
                    Handler.handleResponse(e);
                }
            },

            /**
             * Go to page
             */
            goToPage(page) {
                this.$router.push({ name: page || 'dashboard' });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .profileWrapper
        display: flex
        align-items: flex-start
        margin-top: 9px

    .roleName
        font-size: 13px
        text-transform: capitalize
        color: $theme.darkGrey

    .userName
        font-size: 15px

    .moreWrapper
        position: relative
        cursor: pointer

    .moreWrapper img
        width: 25px
        height: 25px
        border-radius: 25px

    .profileIcon
        margin-left: 5px

    .moreIcon
        position: absolute
        top: 15px
        right: -10px
        background-color: $theme.inputBackground
        border-radius: 50%
        font-size: 20px

    >>> .profileMenu
        padding: 0

        & a:hover
            background: transparent !important
            color: $theme.action

        .v-list__tile
            height: 35px
            padding-right: 90px
            font-size: 13px
            line-height: 16px

    .v-menu__content
        border-radius: 0 !important

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .profileWrapper
            margin-top: 15px

        .profileWrapper.twoLineName
            margin-top: 8px
</style>
